import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BlueprintNameLabelService {
  private blueprintsNameLabelMap = null;
  private blueprintsDropdown: { label: string; value: string }[] = [];
  blueprintsNameLabelMapSubject = new Subject<{
    [key: string]: string;
  }>();

  constructor() {}

  setBlueprintNameLabelMap(stacks) {
    // Create a map with name as the key and label as the value
    this.blueprintsNameLabelMap = stacks.reduce((acc: any, stack: any) => {
      acc[stack?.name] = stack?.label;
      return acc;
    }, {});
    this.blueprintsDropdown = Object.entries(
      this.blueprintsNameLabelMap || {},
    ).map(([key, value]: [string, string]) => ({
      label: value,
      value: key,
    }));
    this.blueprintsNameLabelMapSubject.next(this.blueprintsNameLabelMap);
  }

  async fetchBlueprintNameLabelMap(): Promise<{
    [key: string]: string;
  } | null> {
    if (this.blueprintsNameLabelMap) {
      return this.blueprintsNameLabelMap;
    }

    return new Promise((resolve) => {
      const subscription = this.blueprintsNameLabelMapSubject.subscribe(
        (data) => {
          resolve(data);
          subscription.unsubscribe(); // Unsubscribe after resolving the promise
        },
      );
    });
  }

  getBlueprintsNameLabelMap() {
    return this.blueprintsNameLabelMap;
  }

  getBlueprintsDropdown() {
    return this.blueprintsDropdown || [];
  }
}
